import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Grid,
} from '@mui/material'
import AppDialogTitle from 'components/Dialog/AppDialogTitle'
import CloseDialogButton from 'components/Dialog/CloseDialogButton'
import { useTranslation } from 'react-i18next'

interface IPrintReceiptPreviewModal {
    open: boolean
    title?: string
    previewMarkup?: string
    onClose: () => void
}

const PrintReceiptPreviewModal = (props: IPrintReceiptPreviewModal) => {
    const {
        open = false,
        previewMarkup = '',
        title = 'Preview',
        onClose,
    } = props

    const { t } = useTranslation()

    return (
        <Dialog open={open} fullWidth maxWidth="md" onClose={onClose}>
            <AppDialogTitle text={title} />
            <CloseDialogButton
                dialogName="print receipt preview dialog"
                onClick={onClose}
            />
            <DialogContent style={{ padding: 5, backgroundColor: '#fff' }}>
                <Grid container item justifyContent="center">
                    {previewMarkup && (
                        <img
                            style={{
                                maxWidth: '100%',
                                padding: 12,
                                border: 'solid black 0.25px',
                            }}
                            alt="report-preview"
                            src={previewMarkup}
                        />
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button className="textUpper" color="primary" onClick={onClose}>
                    {t('preview_receipt_modal.lable.close')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default PrintReceiptPreviewModal
